var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "w-50" },
      [
        _c("jodit-editor", {
          model: {
            value: _vm.content,
            callback: function($$v) {
              _vm.content = $$v
            },
            expression: "content"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "w-50 report-size-input p-1" }, [
      _c("div", {
        staticClass:
          "card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end"
      }),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "sidebar-nav" },
        [
          _c("li", { staticClass: "mg-b-10-f font-weight-bold" }, [
            _vm._v("Product")
          ]),
          _vm._v(" "),
          _vm._l(_vm.productForm, function(form) {
            return _c(
              "b-radio",
              {
                key: form.id,
                attrs: { name: "prop", "native-value": form.id },
                nativeOn: {
                  click: function($event) {
                    return _vm.productChange(form.id)
                  }
                },
                model: {
                  value: _vm.productPick,
                  callback: function($$v) {
                    _vm.productPick = $$v
                  },
                  expression: "productPick"
                }
              },
              [_vm._v(_vm._s(form.name))]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "sidebar-nav" },
        [
          _c("li", { staticClass: "mg-b-10-f font-weight-bold" }, [
            _vm._v("Template")
          ]),
          _vm._v(" "),
          _vm._l(_vm.templateForm, function(form) {
            return _c(
              "b-radio",
              {
                key: form.id,
                attrs: { name: "temp", "native-value": form.id },
                nativeOn: {
                  click: function($event) {
                    return _vm.makeA4(form.id)
                  }
                },
                model: {
                  value: _vm.templatePick,
                  callback: function($$v) {
                    _vm.templatePick = $$v
                  },
                  expression: "templatePick"
                }
              },
              [_vm._v(_vm._s(form.name))]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "sidebar-nav mg-t-10-f" },
        [
          _c("li", { staticClass: "mg-b-10-f font-weight-bold" }, [
            _vm._v("Department")
          ]),
          _vm._v(" "),
          _vm._l(_vm.department, function(form) {
            return _c(
              "b-radio",
              {
                key: form,
                attrs: { name: "dept", "native-value": form },
                nativeOn: {
                  click: function($event) {
                    return _vm.classifyGeneralInfo(form)
                  }
                },
                model: {
                  value: _vm.radioPick,
                  callback: function($$v) {
                    _vm.radioPick = $$v
                  },
                  expression: "radioPick"
                }
              },
              [_vm._v(_vm._s(form))]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      this.sampleTypeForm.length != 0
        ? _c(
            "ul",
            { staticClass: "sidebar-nav mg-t-10-f" },
            [
              _c("li", { staticClass: "mg-b-10-f font-weight-bold" }, [
                _vm._v("Sample Type List")
              ]),
              _vm._v(" "),
              _vm._l(_vm.sampleTypeForm, function(form) {
                return _c(
                  "b-radio",
                  {
                    key: form.id,
                    attrs: { name: "samt", "native-value": form.id },
                    nativeOn: {
                      click: function($event) {
                        return _vm.selectSampleType(form.id)
                      }
                    },
                    model: {
                      value: _vm.sampleTypePick,
                      callback: function($$v) {
                        _vm.sampleTypePick = $$v
                      },
                      expression: "sampleTypePick"
                    }
                  },
                  [_vm._v(_vm._s(form.name))]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      this.sampleTypeForm.length != 0
        ? _c(
            "ul",
            { staticClass: "sidebar-nav mg-t-10-f" },
            [
              _c("li", { staticClass: "mg-b-10-f font-weight-bold" }, [
                _vm._v("Sample Group")
              ]),
              _vm._v(" "),
              _vm._l(_vm.sampleTypeForm, function(form) {
                return _c(
                  "b-radio",
                  {
                    key: form.id,
                    attrs: { name: "samt", "native-value": form.id },
                    nativeOn: {
                      click: function($event) {
                        return _vm.sampleGroup(form.id)
                      }
                    },
                    model: {
                      value: _vm.sampleGroupPick,
                      callback: function($$v) {
                        _vm.sampleGroupPick = $$v
                      },
                      expression: "sampleGroupPick"
                    }
                  },
                  [_vm._v(_vm._s(form.name))]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("ul", { staticClass: "sidebar-nav" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c(
              "label",
              { staticClass: "font-weight-bold d-block mg-t-10-f mg-b-10-f" },
              [_vm._v("Sample QC Table")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-block mg-b-10-f" },
              [
                _c("label", { staticClass: "nav-label d-block" }, [
                  _vm._v("Sample Name 선택")
                ]),
                _vm._v(" "),
                _vm._l(_vm.sampleNameForm, function(form) {
                  return _c(
                    "b-radio",
                    {
                      key: form.id,
                      attrs: { name: "temp", "native-value": form.id },
                      nativeOn: {
                        click: function($event) {
                          return _vm.finalFunction(form.id)
                        }
                      },
                      model: {
                        value: _vm.sampleNamePick,
                        callback: function($$v) {
                          _vm.sampleNamePick = $$v
                        },
                        expression: "sampleNamePick"
                      }
                    },
                    [_vm._v(_vm._s(form.name))]
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _vm._l(_vm.sampleQCResult, function(form, i) {
              return _c(
                "div",
                {
                  staticClass:
                    "custom-control custom-checkbox mg-b-7 display-inline-block"
                },
                [
                  _c("label", { staticClass: "nav-label d-block ml-m-1rem" }, [
                    _vm._v(_vm._s(form.name))
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.exp_d_h_info, function(form1, j) {
                    return form1.idx === Number(i) + 1
                      ? _c(
                          "div",
                          {
                            staticClass: "pos-relative-f  wd-25p-f float-left"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.checkedColumn,
                                  expression: "checkedColumn"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: { type: "checkbox", id: form1.columnCode },
                              domProps: {
                                value: form1.columnCode,
                                checked: Array.isArray(_vm.checkedColumn)
                                  ? _vm._i(
                                      _vm.checkedColumn,
                                      form1.columnCode
                                    ) > -1
                                  : _vm.checkedColumn
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.checkedColumn,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = form1.columnCode,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.checkedColumn = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.checkedColumn = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.checkedColumn = $$c
                                    }
                                  },
                                  function($event) {
                                    return _vm.finalFunction()
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: form1.columnCode }
                              },
                              [_vm._v(_vm._s(form1.columnName))]
                            )
                          ]
                        )
                      : _vm._e()
                  })
                ],
                2
              )
            }),
            _vm._v(" "),
            _vm.templatePick == "hab"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "col-lg-4" },
                    [
                      _c("p", { staticClass: "d-block" }, [
                        _vm._v("Bioanalyzer HighSensitivity chip Image")
                      ]),
                      _c("imgUpload", {
                        on: { imgFileHandler: this.imgFileHandler }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-lg-4" },
                    [
                      _c("p", { staticClass: "d-block" }, [
                        _vm._v("DNA Ladder DyneBio Chart Image")
                      ]),
                      _c("imgUpload", {
                        on: { imgFileHandler: this.imgFileHandler2 }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.templatePick == "hab"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "col-lg-5" },
                    [
                      _c("p", { staticClass: "d-block" }, [
                        _vm._v("Purification Chart Image")
                      ]),
                      _c("imgUpload2", {
                        on: { imgFileHandler: this.imgFileHandler3 }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.templatePick == "dft"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "col-lg-5" },
                    [
                      _c("p", { staticClass: "d-block" }, [
                        _vm._v("DNA Quantity Chart Image")
                      ]),
                      _c("imgUpload2", {
                        on: { imgFileHandler: this.imgFileHandler4 }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09e99de7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09e99de7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Common/Editor.vue
// module id = null
// module chunks = 